import { useEffect, useState } from 'react'
import { Box, CircularProgress, IconButton } from '@mui/material'
import * as Icons from '@mui/icons-material'
import { supabase } from '~/supabase-client'
import { TpTooltip } from '~/components'

export default function AccountAvatar({ url, size, onRemove }) {
  const [loading, setLoading] = useState(false)
  const [avatarUrl, setAvatarUrl] = useState(null)

  useEffect(() => {
    if (url) {
      downloadImage(url)
    } else {
      setAvatarUrl(null)
    }
  }, [url])

  async function downloadImage(path) {
    try {
      setLoading(true)
      const { data, error } = await supabase.storage.from('avatars').download(path)
      if (error) {
        throw error
      }
      const url = URL.createObjectURL(data)
      setAvatarUrl(url)
    } catch (error) {
      console.log('Error downloading image: ', error.message)
    }
    setLoading(false)
  }

  if (loading) {
    return <CircularProgress />
  }

  return (
    <Box sx={{ position: 'relative', display: 'inline-block' }}>
      {avatarUrl ? (
        <>
          <Box
            component="img"
            src={avatarUrl}
            alt="Avatar"
            sx={{
              height: size,
              width: size,
              borderRadius: 1,
              overflow: 'hidden',
              objectFit: 'cover',
            }}
          />
          {onRemove && (
            <TpTooltip placement='top' title='Remove your avatar'>
              <IconButton
                onClick={onRemove}
                sx={{
                  position: 'absolute',
                  top: 3,
                  right: 3,
                  padding: 0.25,
                  backgroundColor: 'white',
                  ':hover': {
                    backgroundColor: 'white',
                  }
                }}
                size="small"
                color="error"
              >
                <Icons.Cancel />
              </IconButton>
            </TpTooltip>
          )}
        </>
      ) : (
        <Box
          sx={{
            height: size,
            width: size,
            borderRadius: 1,
            overflow: 'hidden',
            backgroundColor: '#333',
            border: '1px solid rgb(200, 200, 200)',
          }}
        />
      )}
    </Box>
  )
}
